<template>
  <GlobalWindow
    title="编辑"
    :visible.sync="visible"
    :show="true"
    width="20%"
    @confirm="confirm"
    @closeDialog="close"
  >
    <el-form label-width="100px">
      <el-form-item label="公众号：">
        <el-input v-model="currentRowData.account_name" disabled />
      </el-form-item>
      <el-form-item label="appId：">
        <el-input v-model="currentRowData.app_id" disabled />
      </el-form-item>
      <el-form-item label="投放者：">
        <el-select v-model="form.user_id" placeholder="请选择" filterable>
          <el-option
            v-for="item in selectData.filter ? selectData.filter.user : []"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="小说：" prop="novel_name">
        <el-select v-model="form.novel_id" placeholder="请选择" filterable>
          <el-option
            v-for="item in selectData.filter ? selectData.filter.novel : []"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="广告主ID：" prop="advertiser_id">
        <el-select v-model="form.advertiser_id" filterable placeholder="请选择">
          <el-option
            v-for="item in selectData.filter ? selectData.filter.advertisers : []"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="状态：" prop="status">
        <span>
          <el-radio v-model="form.status" :label="1">正常</el-radio>
          <el-radio v-model="form.status" :label="0">解绑</el-radio>
        </span>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow'
export default {
  name: 'UpdateWindow',
  components: { GlobalWindow },
  props: {
    // 获取父组件筛选列表
    selectData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      currentRowData: {},
      visible: false,
      id: null,
      // 收集表单数据
      form: {
        user_id: null,
        novel_id: null,
        advertiser_id: null,
        status: 1
      }
    }
  },
  methods: {
    open(data) {
      this.visible = true
      this.currentRowData = data // 获取当前行的数据
      this.form.status = data.status // 获取当前行的状态
      this.id = data.id // 获取当前行的ID
    },
    confirm() {
      if (!this.form.user_id === null || !this.form.novel_id || !this.form.advertiser_id) {
        this.$message({
          message: '修改项不能为空',
          type: 'error'
        })
        return
      }
      this.$emit('confirm', this.id, this.form)
      this.form = {}
      this.id = null
      this.visible = false
    },
    close() {
      this.form = {}
      this.id = null
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
